import GrowthReport from './GrowthReport.jsx';
export default GrowthReport;